import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_DELETE_BUTTON } from '../../../constants'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { DeleteButton as DeleteButtonUnified } from './DeleteButton'
import { DeleteButtonLegacy } from './DeleteButtonLegacy'
import type { DeleteButtonProps } from './DeleteButtonProps'

export type { DeleteButtonProps }

/**
 * Shared icon-only delete action.
 *
 * Renders a trash icon inside a button. During migration, the feature flag
 * selects either the Helios Classic implementation or the UC IconButton
 * implementation. Consumers should provide the accessible label and click
 * handler; legacy-only props are supported temporarily.
 */
export const DeleteButton: React.FC<DeleteButtonProps> = props =>
  getFeatureFromCache(FEATURE_UC_IN_WEBREGISTER_DELETE_BUTTON) ? (
    <DeleteButtonUnified {...props} />
  ) : (
    <DeleteButtonLegacy {...props} />
  )
